<template lang="html">
<div>

    <div class="subpage affairs3">

          <div class="headLine clearfix">
              <div class="bName">材料</div>
              <div class="bContent">
                  <el-button @click="fliesHandle('add')" size="small" class="add" type="primary">添加</el-button>
              </div>
          </div>

          <div class="table">

            <el-table
                 :data="listDat"
                 header-row-class-name="tableHead"
                 style="width: 100%">
                 <el-table-column
                   prop="name"
                   label="材料名称">
                 </el-table-column>
                 <el-table-column
                   prop="source"
                   label="材料来源">
                 </el-table-column>
                 <el-table-column
                   prop="originalNumber"
                   label="原件份数"
                   align="center"
                   width="180">
                 </el-table-column>
                 <el-table-column
                   prop="photocopyNumber"
                   label="复印件份数"
                   align="center"
                   width="180">
                 </el-table-column>
                 <el-table-column
                   width="180"
                   align="center"
                   label="操作">

                    <template slot-scope="scope">
                        <el-button @click="fliesHandle('edit',scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                        <el-button @click="fliesHandle('remove',scope.$index)" size="small" type="danger">删除</el-button>
                    </template>

                 </el-table-column>
               </el-table>
          </div>


    </div>

    <newMet ref="newMet" @goAdd="goAdd" />

</div>
</template>

<script>
import newMet from "./newMet";
export default {
    props:['affid'],
    components:{
        newMet
    },
    data(){
        return{
            listDat:[],
            openstate:false,
            params:{
                textarea:''
            }
        }
    },
    methods:{
        fliesHandle:function(etype,inx,edat){
            if(etype == 'add'){
                this.$refs.newMet.openstate = true;
            }else if(etype == 'edit'){
                this.$refs.newMet.openstate = true;
                this.$refs.newMet.goEdit(edat,inx);
            }else if(etype == 'remove'){
                this.listDat.splice(inx,1);
            }
        },
        goAdd:function(e){
            var item = {};
            for(var key in e.data){
                item[key] = e.data[key];
                item.cqjZhengwuHandleMattersId = this.affid;
            };
            if(e.inx || e.inx === 0){
              this.listDat.splice(e.inx,1,item);
            }else{
              this.listDat.push(item);
            }
        },
        preEdit:function(res){
            this.listDat = res.applicationMaterialsList;
        },
        saveReturn:function(){
            return this.listDat;
        }
    }
}
</script>

<style lang="scss" scoped>

.headLine{
    .bName{
        width: 60px;
        margin-top: 6px;
        float: left;
        margin-bottom: 20px;
    }
    .bContent{
        margin-left: 60px;
        position: relative;
        .add{
             width: 90px;
        }
    }
}

.table{
      margin-bottom: 20px;
      margin-left: 60px;
}

</style>

<style lang="scss">

.affairs3 .tableHead th{
      background: #f5f5f5;
      font-weight: normal;
      color: #666666;
}

</style>



// WEBPACK FOOTER //
// Subpage3.vue?047e5a14